
import React from "react"
import { CircleMarker, Popup } from "react-leaflet";

const ElevationMarker = (props) => {
    let delta = props.text - props.homeSurfaceAlt;
    let color = '#ffffff';
    if (delta >= 0 && delta <= 10) {
      color = '#001df9'; //blue
    } else if (delta >= 10 && delta < 15) {
      color = '#007afa'; //light blue
    } else if (delta >= 15 && delta < 20) {
      color = '#00fffe'; //lighter blue
    } else if (delta >= 20 && delta < 25) {
      color = '#00ff7d'; //light green
    } else if (delta >= 25 && delta < 30) {
      color = '#00ff33'; //green
    } else if (delta >= 30 && delta < 35) {
      color = '#fffd3a'; //yellow
    } else if (delta >= 35 && delta < 40) {
      color = '#FF8100'; //orange
    } else if (delta >= 40 && delta < 45) {
      color = '#ff0117'; //red
    } else if (delta >= 45) {
      color = '#ffffff';
    } else if (delta <= 0 && delta > -10) {
      color = '#580A0A';
    } else if (delta <= -10 && delta > -20) {
      color = '#AF5D16';
    } else if (delta <= -20 && delta > -30) {
      color = '#561769';
    } else if (delta <= -30 && delta > -40) {
      color = '#6C6613';
    } else if (delta < -40) {
      color = 'black';
    }
    return (
      <CircleMarker
        center={props.position}
        radius={2}
        color={color}
        fillColor={color}
        fillOpacity={1}
        onMouseOver={(e) => {
          e.target.openPopup();
        }}
        onMouseOut={(e) => {
          e.target.closePopup();
        }}
      >
        <Popup>
          <span>El: {props.text}</span>
          <span> Delta: {delta}</span>
        </Popup>
      </CircleMarker>
    )
}

export default ElevationMarker;
  